module.exports = __webpack_public_path__ + "img/christmas.40741508.png";